import { motion } from "framer-motion";

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.2, 0.7, 0.2, 1] },
};

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    {...fadeUp}
    transition={{ ...fadeUp.transition, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export default FadeUp;
